import { MapGeoJSONFeature } from "maplibre-gl";
import { DataType } from "../types/lib/types";

/**
 * 指定したレイヤー群にfeatureがなければ、item.dataIdに応じてエラーメッセージを返す
 */
export const getFiwareErrorMessages = ( features: MapGeoJSONFeature[], item: DataType, fiwareFetchStatuses: {[key: string]: boolean} ): string[] => {
  const title = item.id.includes('/') ? item.id.split('/').slice(-1)[0] : item.id;
  const errorMsgArr: string[] = [];

  const fiwareFetchStatus = item.dataType === 'fiware' ? fiwareFetchStatuses[item.dataId || ''] : undefined;
  if (fiwareFetchStatus !== undefined && !fiwareFetchStatus) {
    if (item.dataId?.includes('EvacuationShelter')) {
      errorMsgArr.push('避難所開設状況 のデータ連携は停止しています');
    } else if (item.dataId?.includes('Disasterreports')) {
      errorMsgArr.push('最新の災害パトロール情報 のデータ連携は停止しています');
    } else if (item.dataId?.includes('EvacuationInformation')) {
      errorMsgArr.push(`${title}の避難情報 のデータ連携は停止しています`);
    } else {
      errorMsgArr.push(`${title} のデータ連携は停止しています`);
    }
    return errorMsgArr;
  }

  if (item.dataType === 'fiware' && features.length === 0) {
    if (item.dataId?.includes('EvacuationShelter')) {
      errorMsgArr.push('避難所は全て閉鎖中です');
    }
    if (item.dataId?.includes('Disasterreports')) {
      errorMsgArr.push('最新の災害パトロール情報はありません');
    }
    if (item.dataId?.includes('EvacuationInformation')) {
      errorMsgArr.push(`発令中の${title}の避難情報はありません`);
    }
  }

  return errorMsgArr;
};
